export enum WizardActionType {
  SET_LOADING_OVERLAY_VISIBLE = 'SET_LOADING_OVERLAY_VISIBLE',
}

export type SetLoadingOverlayVisible = {
  type: WizardActionType.SET_LOADING_OVERLAY_VISIBLE;
  isVisible: Boolean;
};

export type WizardAction = SetLoadingOverlayVisible;
